<template>
  <div class="container login">
    <form class="mt-4" @submit.prevent="getToken(credentials)">
      <div v-if="response.message" class="alert alert-danger">
        {{ response.message }}
      </div>
      <div class="form-group">
        <input type="text" class="form-control" :class="{ 'is-invalid': response.errors.user }" placeholder="User ..." v-model="credentials.user">
        <div v-if="response.errors.user" class="invalid-feedback">
          Please provide a user
        </div>
      </div>
      <div class="form-group">
        <input type="password" class="form-control" :class="{ 'is-invalid': response.errors.password }" placeholder="Password ..." v-model="credentials.password">
        <div v-if="response.errors.password" class="invalid-feedback">
          Please provide a password
        </div>
      </div>
      <button type="submit" class="btn btn-primary">Login</button>
    </form>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  data() {
    return {
      credentials: {
        user: '',
        password: '',
      }
    }
  },
  computed: {
    ...mapState(['response']),
  },
  methods: {
    ...mapActions(['getToken']),
  }
}
</script>

<style lang="scss">
.login {
  max-width: 400px;
}
</style>